export function getBgColor(strength, maxStrength, history, theme) {
  if (history)
    return `repeating-linear-gradient( 135deg, ${theme.colors.backgroundPrimary}, ${theme.colors.backgroundPrimary} 3px, #808080 2px, #808080 8px)`;
  const hue = (120 * Math.min(strength, maxStrength)) / maxStrength;
  return `hsl(${hue}, 90%, 50%)`;
}
